import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { changeCurrency } from '../../actions/settingsActions';
import ModalPickerSelector from '../ModalSelector/ModalPickerSelector';

const CurrencySelectorWithPicker = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currencies = useSelector((state) => state?.currency);
  const selectedCurrency = currencies?.selected ? currencies.selected : { name: '', shortForm: '' };

  const options =
    currencies.all?.map((c) => ({
      value: c.shortForm,
      label: `${c.name} (${c.shortForm})`,
      original: c,
    })) || [];

  const selectedValue = options.find((opt) => opt.value === selectedCurrency?.shortForm);

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      dispatch(changeCurrency(selectedOption.original));
    }
  };

  return (
    <div className='row align-items-center'>
      <div className='col fw-semibold font-tiny text-secondary text-center pr-1'>
        {t('priceIn', { currency: selectedValue.label })}
      </div>
      <div className='col-auto pl-1'>
        <div className='text-center'>
          <ModalPickerSelector
            title={t('bankForm.selectCurrency')}
            options={options}
            selectedValue={selectedValue}
            onChange={handleChange}
            formatOptionLabel={(c) => <div className='option-inner'>{c.label}</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default CurrencySelectorWithPicker;
